<template>
  <div class="upload" v-show="show">
    <div class="w100 po-r pt10 pb10 tx-c font-16 bor-b">
      文件上传
      <!-- <i class="po-a upload-pile el-icon-minus"></i> -->
      <i class="po-a upload-off el-icon-close cu-p" @click="hideView"></i>
    </div>
    <div class="upload-list">
      <!-- <div class="w100 pl10 pr10 pt5 pb5 flex-box">
        <div class="flex-1"></div>
        <span class="cu-p grey" @click="clearFileList">清除</span>
      </div> -->
      <uploader ref="uploader" :options="options" :file-status-text="fileStatusText" @file-success="fileSuccess" @file-error="fileError" @complete="complete" @file-added="fileAdded">
        <uploader-unsupport>您的浏览器不支持HTML5 File API，请使用Chrome等现代浏览器。</uploader-unsupport>
        <!-- <uploader-btn>选择文件</uploader-btn> -->
        <uploader-list></uploader-list>
      </uploader>
    </div>
  </div>
</template>

<script>
import Bus from "@/assets/js/bus";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: [],
  data() {
    return {
      show: false,
      options: {
        target: this.$base.uploadUrl,
        // withCredentials: true,
        prioritizeFirstAndLastChunk: true,
        testChunks: true,
        generateUniqueIdentifier: chunk => {
          // const str = this.$options.filters.roll(12, "-", 4);
          return chunk.uid;
        },
        checkChunkUploadedByResponse: (chunk, message) => {
          let objMessage = JSON.parse(message);
          if (objMessage.resData.skipUpload) {
            return true;
          }
          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        }
      },
      fileStatusText: {
        success: "完成",
        error: "失败",
        uploading: "上传中",
        paused: "暂停",
        waiting: "等待"
      },
      // 上传完成后的id集合
      ids: []
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {
    const authorization = "bearer " + this.$keycloak.token;
    this.options.headers = {
      Accept: "application/json",
      Authorization: authorization,
      token: this.userToken
    };
  },
  mounted() {
    Bus.$on("add-files", fileList => {
      this.show = true;
      this.$nextTick(() => {
        for (const item of fileList) {
          this.$refs.uploader.uploader.addFile(item);
        }
      });
    });
  },
  methods: {
    complete() {
      Bus.$emit("complete-upload", this.ids);
    },
    fileSuccess(rootFile, file, message, chunk) {
      this.ids.push({
        id: file.uniqueIdentifier,
        type: "success"
      });
    },
    fileError(rootFile, file, message, chunk) {
      this.ids.push({
        id: file.uniqueIdentifier,
        type: "error"
      });
    },
    hideView() {
      this.show = false;
      this.$refs.uploader.uploader.cancel();
    },
    clearFileList() {
      this.$refs.uploader.uploader.cancel();
    },
    fileAdded(file) {}
  },
  watch: {},
  destroyed() {}
};
</script>

<style scoped>
.upload {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 500px;
  height: 300px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  z-index: 60;
  overflow: hidden;
}

.upload-list {
  height: 257px;
  overflow-y: auto;
}

.upload-pile,
.upload-off {
  color: #666666;
  top: 50%;
  margin: -0.5em 0 0 0;
}

.upload-off {
  right: 10px;
}

.upload-pile {
  right: 30px;
}
</style>